import type { ProcessInstanceStatus } from '../../../types/workflow-v9';
import { EnterpriseStatusBadge, type EnterpriseStatusTone } from '../../shared/components/EnterpriseStatusBadge';

interface ExecutionStatusBadgeProps {
  status: ProcessInstanceStatus;
}

const STATUS_STYLES: Record<ProcessInstanceStatus, { label: string; tone: EnterpriseStatusTone }> = {
  active: {
    label: 'ATIVO',
    tone: 'active',
  },
  completed: {
    label: 'CONCLUIDO',
    tone: 'completed',
  },
  cancelled: {
    label: 'CANCELADO',
    tone: 'archived',
  },
  on_hold: {
    label: 'EM_ESPERA',
    tone: 'warning',
  },
  failed: {
    label: 'FALHOU',
    tone: 'risk',
  },
};

export function ExecutionStatusBadge({ status }: ExecutionStatusBadgeProps) {
  const style = STATUS_STYLES[status];
  return <EnterpriseStatusBadge label={style.label} tone={style.tone} />;
}
